(function($) {
  if (!$) return;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function injectStyles() {
    if (document.getElementById('pu-search-autocomplete-style')) return;
    var css = [
      '.search-results{z-index:10020!important;list-style:none!important;width:min(700px,92vw)!important;max-height:min(76vh,660px)!important;margin:0!important;padding:6px!important;background:#fff!important;border:1px solid #d7dce4!important;border-radius:8px!important;box-shadow:0 14px 34px rgba(18,26,45,.16)!important;overflow-y:auto!important;}',
      '.search-results li{display:block!important;width:100%!important;margin:0!important;padding:0!important;border:0!important;line-height:normal!important;height:auto!important;overflow:visible!important;}',
      '.search-results li+li{margin-top:2px!important;}',
      '.search-results .pu-search-result-card{display:grid!important;grid-template-columns:52px minmax(0,1fr) auto!important;gap:10px!important;align-items:start!important;min-height:58px!important;padding:6px 8px!important;color:#161b2d!important;border-radius:7px!important;text-decoration:none!important;background:#fff!important;}',
      '.search-results .pu-search-result-card:hover,.search-results .pu-search-result-card:focus{background:#f5f7fb!important;}',
      '.search-results .pu-search-result-image{display:flex!important;align-items:center!important;justify-content:center!important;width:52px!important;height:52px!important;border:1px solid #e2e6ee!important;border-radius:6px!important;background:#fff!important;overflow:hidden!important;}',
      '.search-results .pu-search-result-image img{display:block!important;max-width:46px!important;max-height:46px!important;object-fit:contain!important;}',
      '.search-results .pu-search-result-body{display:block!important;min-width:0!important;text-align:left!important;}',
      '.search-results .pu-search-result-title{display:-webkit-box!important;overflow:hidden!important;color:#111827!important;font-size:13px!important;font-weight:700!important;line-height:1.28!important;text-overflow:ellipsis!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:2!important;}',
      '.search-results .pu-search-result-side{display:flex!important;flex-direction:column!important;align-items:flex-end!important;min-width:72px!important;text-align:right!important;}',
      '.search-results .pu-search-result-price{color:#0404CD!important;font-size:13px!important;font-weight:800!important;line-height:1.2!important;}',
      '.search-results .pu-search-result-more a{display:block!important;padding:8px 10px!important;color:#0404CD!important;font-size:13px!important;font-weight:800!important;text-align:center!important;text-decoration:none!important;border-radius:7px!important;background:#f4f5ff!important;}',
      '@media(max-width:640px){.search-results{left:0!important;right:0!important;width:calc(100vw - 24px)!important;max-height:72vh!important;}.search-results .pu-search-result-card{grid-template-columns:48px minmax(0,1fr) auto!important;gap:8px!important;min-height:54px!important;}.search-results .pu-search-result-image{width:48px!important;height:48px!important;}.search-results .pu-search-result-image img{max-width:42px!important;max-height:42px!important;}.search-results .pu-search-result-side{grid-column:3!important;align-items:flex-end!important;min-width:0!important;width:auto!important;text-align:right!important;}.search-results .pu-search-result-title{font-size:12.5px!important;line-height:1.25!important;}.search-results .pu-search-result-price{font-size:13px!important;}}'
    ].join('');
    $('<style id="pu-search-autocomplete-style"></style>').text(css).appendTo('head');
  }

  function initSearchForm() {
    injectStyles();
    $('form[action="/search"]').each(function() {
      var form = $(this);
      var input = form.find('input[name="q"]').first();
      if (!input.length) return;

      input.off('keyup change');
      form.off('submit.puSearchAutocomplete');
      form.find('.search-results').remove();
      form.css('position', 'relative');

      var offSet = input.position().top + input.innerHeight();
      $('<ul class="search-results"></ul>').css({
        position: 'absolute',
        left: '0px',
        top: offSet
      }).appendTo(form).hide();

      var currentRequest = null;
      form.on('submit.puSearchAutocomplete', function() {
        var submitTerm = $.trim(input.val());
        if (submitTerm.length > 2 && submitTerm.slice(-1) !== '*') {
          input.val(submitTerm + '*');
        }
      });

      input.attr('autocomplete', 'off').on('keyup.puSearchAutocomplete change.puSearchAutocomplete', function() {
        var rawTerm = $.trim(input.val());
        var term = rawTerm + '*';
        var resultsList = form.find('.search-results');
        if (term.length <= 3 || term === input.attr('data-pu-old-term')) return;

        input.attr('data-pu-old-term', term);
        if (currentRequest) currentRequest.abort();

        var searchURL = '/search?type=product&q=' + encodeURIComponent(term);
        currentRequest = $.getJSON(searchURL + '&view=json', function(data) {
          resultsList.empty();
          if (!data || !data.results_count) {
            resultsList.hide();
            return;
          }

          $.each(data.results || [], function(index, item) {
            var link = $('<a class="pu-search-result-card"></a>').attr('href', item.url);
            var thumbnail = item.thumbnail || '';
            link.append('<span class="pu-search-result-image"><img src="' + escapeHtml(thumbnail) + '" alt="" loading="lazy"></span>');
            link.append('<span class="pu-search-result-body"><span class="pu-search-result-title">' + escapeHtml(item.title) + '</span></span>');
            link.append('<span class="pu-search-result-side"><span class="pu-search-result-price">' + escapeHtml(item.price) + '</span></span>');
            resultsList.append($('<li></li>').append(link));
          });

          if (data.results_count > (data.results || []).length) {
            resultsList.append('<li class="pu-search-result-more"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></li>');
          }
          resultsList.fadeIn(120);
        });
      });
    });
  }

  $(function() {
    initSearchForm();
    $('body').off('click.puSearchAutocomplete').on('click.puSearchAutocomplete', function(event) {
      if (!$(event.target).closest('form[action="/search"]').length) {
        $('.search-results').hide();
      }
    });
  });
})(window.jQuery);

(function() {
  var pages = {
    '/products/deutsch-hdp26-24-29se-hdp29-f': true,
    '/products/deutsch-hd34-24-29pe-hd30-29-pin-male-connector': true
  };
  var desired = [
    {
      handle: 'deutsch-hdp20-series-lock-washer-size-24-usa',
      title: 'Deutsch 2414-001-2486 HDP20 Lock Washer (Size 24)',
      role: 'Size 24 HDP20 lock washer',
      sku: 'TEC-2414-001-2486',
      price: '$2.99',
      stock: 'Available',
      variantId: '34418448891949',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-2414-001-2486_01_03797be9-138a-44a0-b6fe-3a767d47717b_360x360.jpg?v=1589892708'
    },
    {
      handle: 'deutsch-112264-zz-hd30-series-lock-washer-size-24',
      title: 'Deutsch 112264-ZZ HD30 Series Lock Washer (Size 24)',
      role: 'Size 24 HD30 lock washer',
      sku: 'TEC-112264-ZZ',
      price: '$1.79',
      stock: 'Available',
      variantId: '48036319789333',
      image: '//mypartsuniverse.com/cdn/shop/files/112264-ZZ_01_360x360.jpg?v=1709324768'
    },
    {
      handle: 'deutsch-114017-14-16awg-seal-plug',
      title: 'DEUTSCH 114017 12-16AWG Sealing Plug',
      role: 'Seal plug for unused size 12/16 cavities',
      sku: 'TEC-114017',
      price: '$0.49',
      stock: 'Available',
      variantId: '34418293604397',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-114017_01_360x360.jpg?v=1589891074'
    },
    {
      handle: 'deutsch-0413-204-2005-20awg-seal-plug',
      title: 'DEUTSCH 0413-204-2005 20AWG Seal Plug',
      role: 'Seal plug for unused size 20 cavities',
      sku: 'TEC-0413-204-2005',
      price: '$0.59',
      stock: 'Available',
      variantId: '34418290229293',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-0413-204-2005_01_360x360.jpg?v=1589891006'
    },
    {
      handle: 'deutsch-hd30-24bt-90-bk-black-90-deg-boot-size-24',
      title: 'DEUTSCH HD30-24BT-90-BK 90 degree Black Boot For HDP20 HD30 Connector (Size 24)',
      role: 'Size 24 90 degree boot',
      sku: 'TEC-HD30-24BT-90-BK',
      price: '$6.49',
      stock: 'Available',
      variantId: '34418322735149',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-HD30-24BT-90-BK_01_360x360.jpg?v=1589891358'
    },
    {
      handle: 'deutsch-whds-24-2-hd30-90-deg-strain-relief',
      title: 'DEUTSCH WHDS-24-2 90 degree Strain Relief For HD30 Connectors',
      role: 'Size 24 90 degree strain relief',
      sku: 'TEC-WHDS-24-2',
      price: '$21.99',
      stock: 'Available',
      variantId: '34418325880877',
      image: '//mypartsuniverse.com/cdn/shop/products/TEC-WHDS-24-2_01_360x360.jpg?v=1589891421'
    }
  ];

  function makeCard(item) {
    var article = document.createElement('article');
    article.className = 'pu-related-card';
    article.setAttribute('data-pu-hd-accessory-fallback', item.sku);
    article.innerHTML = [
      '<a class="pu-related-card__media" href="/products/' + item.handle + '" aria-label="' + item.title + '">',
      '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy">',
      '</a>',
      '<div class="pu-related-card__body">',
      '<span class="pu-related-card__role">' + item.role + '</span>',
      '<a class="pu-related-card__title" href="/products/' + item.handle + '">' + item.title + '</a>',
      '<span class="pu-related-card__sku">SKU: ' + item.sku + '</span>',
      '<div class="pu-related-card__meta"><span class="pu-related-card__price">' + item.price + '</span><span class="pu-related-card__stock">' + item.stock + '</span></div>',
      '<form class="pu-related-card__cart" method="post" action="/cart/add"><input type="hidden" name="id" value="' + item.variantId + '"><input type="hidden" name="quantity" value="1"><button class="pu-related-card__add" type="submit">Add to cart</button></form>',
      '<a class="pu-related-card__cta" href="/products/' + item.handle + '">View item</a>',
      '</div>'
    ].join('');
    return article;
  }

  function applyHdSize24AccessoryFallback() {
    if (!pages[window.location.pathname]) return;
    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var i = 0; i < groups.length; i += 1) {
      var heading = groups[i].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Hardware & Protection') continue;
      var grid = groups[i].querySelector('.pu-related-card-grid');
      if (!grid) return;
      var currentText = groups[i].textContent;
      for (var itemIndex = 0; itemIndex < desired.length; itemIndex += 1) {
        var item = desired[itemIndex];
        if (currentText.indexOf(item.sku) !== -1 || currentText.indexOf(item.sku.replace('TEC-', '')) !== -1) continue;
        grid.appendChild(makeCard(item));
        currentText += ' ' + item.sku + ' ' + item.title;
      }
    }
    dedupeHardwareProtectionCards();
  }

  function dedupeHardwareProtectionCards() {
    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var i = 0; i < groups.length; i += 1) {
      var heading = groups[i].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Hardware & Protection') continue;
      var seen = {};
      var cards = groups[i].querySelectorAll('.pu-related-card');
      for (var j = 0; j < cards.length; j += 1) {
        var skuText = cards[j].querySelector('.pu-related-card__sku');
        var sku = skuText ? skuText.textContent.replace(/^SKU:\s*/i, '').trim() : '';
        if (!sku) continue;
        if (seen[sku]) {
          cards[j].remove();
        } else {
          seen[sku] = true;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHdSize24AccessoryFallback);
  } else {
    applyHdSize24AccessoryFallback();
  }
  window.setTimeout(applyHdSize24AccessoryFallback, 1000);
  window.setTimeout(applyHdSize24AccessoryFallback, 2500);
  window.setTimeout(dedupeHardwareProtectionCards, 3500);
})();

(function() {
  if (window.location.pathname !== '/') return;

  var cards = [
    ['Automotive', 'Batteries, wipers, brake, fuel, cooling', '/collections/all/industry-automotive'],
    ['Marine & RV', 'Marine service, trailer, RV accessories', '/collections/all/industry-marine-and-rv'],
    ['Electrical', 'Connectors, terminals, relays, wire', '/collections/all/industry-electrical'],
    ['Industrial', 'Supplies, electrical parts, hardware', '/collections/all/industry-industrial'],
    ['Manufacturing', 'Tools, shop supplies, chemicals, maintenance', '/collections/all/industry-shop-and-manufacturing'],
    ['Home & Shop', 'Office, shop, repair supplies', '/collections/all/industry-home'],
    ['Other', 'Special order, hard-to-find parts, support', '/pages/all-categories#miscellaneous']
  ];

  function injectStyle() {
    if (document.getElementById('pu-home-category-helper-style')) return;
    var style = document.createElement('style');
    style.id = 'pu-home-category-helper-style';
    style.textContent = [
      'body:not(.pu-home-industry-ready) .pu-home-category-directory-link{display:none;}',
      '#shopify-section-1570867963191 .pu-home-command-center{display:grid;grid-template-columns:minmax(220px,.9fr) minmax(0,1.6fr);gap:16px;align-items:stretch;margin:0 0 14px;padding:18px;border:1px solid rgba(24,35,52,.08);border-radius:8px;background:#fff;box-shadow:0 10px 24px rgba(24,35,52,.08);}',
      '#shopify-section-1570867963191 .pu-home-command-center__copy{display:flex;flex-direction:column;justify-content:center;min-width:0;}',
      '#shopify-section-1570867963191 .pu-home-command-center__eyebrow{margin-bottom:5px;color:#0404cd;font-size:12px;font-weight:900;line-height:1.2;text-transform:uppercase;}',
      '#shopify-section-1570867963191 .pu-home-command-center h1{margin:0 0 5px;color:#111827;font-size:28px;font-weight:900;letter-spacing:0;line-height:1.08;}',
      '#shopify-section-1570867963191 .pu-home-command-center p{margin:0;color:#626b78;font-size:14px;line-height:1.35;}',
      '#shopify-section-1570867963191 .pu-home-command-center__actions{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:9px;}',
      '#shopify-section-1570867963191 .pu-home-command-center__actions a{display:flex;flex-direction:column;justify-content:center;min-height:74px;padding:13px 12px;border:1px solid #d8dee8;border-radius:7px;background:#f8fafc;color:#111827;text-decoration:none;}',
      '#shopify-section-1570867963191 .pu-home-command-center__actions a:hover,#shopify-section-1570867963191 .pu-home-command-center__actions a:focus{border-color:#0404cd;background:#f4f5ff;}',
      '#shopify-section-1570867963191 .pu-home-command-center__actions span{margin-bottom:4px;color:#111827;font-size:15px;font-weight:900;line-height:1.15;}',
      '#shopify-section-1570867963191 .pu-home-command-center__actions small{color:#667080;font-size:11px;font-weight:600;line-height:1.25;}',
      '.pu-home-category-directory-link{margin:10px auto 18px;text-align:center;}',
      '.pu-home-category-directory-link a{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:42px;padding:10px 16px;border:1px solid #0404cd;border-radius:4px;background:#0404cd;color:#fff;font-size:14px;font-weight:800;line-height:1.2;text-decoration:none;box-shadow:0 10px 22px rgba(4,4,205,.18);}',
      '.pu-home-category-directory-link a:hover,.pu-home-category-directory-link a:focus{border-color:#03039b;background:#03039b;color:#fff;}',
      '.pu-home-mobile-nav{display:none!important;}',
      '@media screen and (max-width:767px){body.pu-home-industry-ready{padding-bottom:0!important;}#shopify-section-1570867963191 .engoc-scolv2{padding-top:10px!important;}#shopify-section-1570867963191 .engoc-scolv2>.container{display:flex!important;flex-direction:column!important;}#shopify-section-1570867963191 .azirspares-tabs.style6{order:1!important;}#shopify-section-1570867963191 .pu-industry-hub{order:2!important;margin-bottom:10px!important;padding:11px!important;}#shopify-section-1570867963191 .pu-home-command-center{order:3!important;display:block!important;margin:14px 0 10px!important;padding:11px!important;}#shopify-section-1570867963191 .pu-home-command-center__eyebrow{font-size:11px!important;}#shopify-section-1570867963191 .pu-home-command-center h1{font-size:19px!important;}#shopify-section-1570867963191 .pu-home-command-center p{display:none!important;}#shopify-section-1570867963191 .pu-home-command-center__actions{display:flex!important;gap:8px!important;margin:9px -11px 0!important;overflow-x:auto!important;padding:0 11px 2px!important;-webkit-overflow-scrolling:touch!important;scrollbar-width:none!important;}#shopify-section-1570867963191 .pu-home-command-center__actions::-webkit-scrollbar{display:none!important;}#shopify-section-1570867963191 .pu-home-command-center__actions a{flex:0 0 118px!important;min-height:52px!important;padding:9px!important;}#shopify-section-1570867963191 .pu-home-command-center__actions span{margin-bottom:2px!important;font-size:12px!important;}#shopify-section-1570867963191 .pu-home-command-center__actions small{font-size:9px!important;}#shopify-section-1570867963191 .pu-industry-hub__head{margin-bottom:9px!important;}#shopify-section-1570867963191 .pu-industry-hub__subtitle{display:none!important;}#shopify-section-1570867963191 .pu-industry-hub__grid{display:flex!important;gap:8px!important;margin:0 -11px!important;overflow-x:auto!important;padding:0 11px 2px!important;-webkit-overflow-scrolling:touch!important;scrollbar-width:none!important;}#shopify-section-1570867963191 .pu-industry-hub__grid::-webkit-scrollbar{display:none!important;}#shopify-section-1570867963191 .pu-industry-hub__card{flex:0 0 132px!important;min-height:54px!important;padding:10px!important;}#shopify-section-1570867963191 .pu-industry-hub__name{margin-bottom:0!important;font-size:12px!important;}#shopify-section-1570867963191 .pu-industry-hub__meta{display:none!important;}.pu-home-category-directory-link{display:none!important;}.pu-home-mobile-nav{display:none!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function makeCard(card) {
    var link = document.createElement('a');
    link.className = 'pu-industry-hub__card';
    link.href = card[2];
    link.innerHTML = '<span class="pu-industry-hub__name">' + card[0] + '</span><span class="pu-industry-hub__meta">' + card[1] + '</span>';
    return link;
  }

  function applyHomeCategoryHelper() {
    var staleCommandCenter = document.querySelector('.pu-home-command-center');
    if (staleCommandCenter && staleCommandCenter.parentNode) staleCommandCenter.parentNode.removeChild(staleCommandCenter);
    var staleMobileNav = document.querySelector('.pu-home-mobile-nav');
    if (staleMobileNav && staleMobileNav.parentNode) staleMobileNav.parentNode.removeChild(staleMobileNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyHomeCategoryHelper);
  } else {
    applyHomeCategoryHelper();
  }
  window.addEventListener('load', applyHomeCategoryHelper);
  window.setTimeout(applyHomeCategoryHelper, 500);
  window.setTimeout(applyHomeCategoryHelper, 1500);
})();

(function() {
  function dedupeHardwareProtectionCards() {
    var groups = document.querySelectorAll('.pu-compatible-group');
    for (var i = 0; i < groups.length; i += 1) {
      var heading = groups[i].querySelector('h3');
      if (!heading || heading.textContent.trim() !== 'Hardware & Protection') continue;
      var seen = {};
      var cards = groups[i].querySelectorAll('.pu-related-card');
      for (var j = 0; j < cards.length; j += 1) {
        var skuText = cards[j].querySelector('.pu-related-card__sku');
        var sku = skuText ? skuText.textContent.replace(/^SKU:\s*/i, '').trim() : '';
        if (!sku) continue;
        if (seen[sku]) {
          cards[j].remove();
        } else {
          seen[sku] = true;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dedupeHardwareProtectionCards);
  } else {
    dedupeHardwareProtectionCards();
  }
  document.addEventListener('click', function(event) {
    if (event.target.closest && event.target.closest('[data-pu-tab-target], .pu-te-nav a, [role="tab"]')) {
      window.setTimeout(dedupeHardwareProtectionCards, 50);
      window.setTimeout(dedupeHardwareProtectionCards, 350);
    }
  }, true);
  window.setTimeout(dedupeHardwareProtectionCards, 1000);
  window.setTimeout(dedupeHardwareProtectionCards, 2500);
  window.setTimeout(dedupeHardwareProtectionCards, 5000);
})();

/* PU_TOOLS_CATEGORY_IMAGE_FIX_20260609 */
(function () {
  var NEW_SRC = 'https://mypartsuniverse.com/cdn/shop/t/18/assets/home-category-tools-steinel-pliers.png?v=1780988391';
  function updateToolsImage() {
    var cards = document.querySelectorAll('.category-item');
    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      var title = card.querySelector('.title');
      var link = card.querySelector('a[href*="/collections/tools-equipment"]');
      if (!title || !link || !/^\s*Tools\s*$/i.test(title.textContent || '')) continue;
      var img = card.querySelector('img');
      if (!img) continue;
      img.src = NEW_SRC;
      img.removeAttribute('srcset');
      img.alt = 'Tools';
      break;
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateToolsImage);
  } else {
    updateToolsImage();
  }
  window.addEventListener('load', updateToolsImage);
})();
;(function() {
  if (!/^\/collections\/batteries\/?$/.test(window.location.pathname)) return;

  function loadFitment(callback) {
    if (window.PUBatteryYMMData) {
      callback();
      return;
    }
    var existing = document.querySelector('script[src*="pu-battery-ymm-fitment.js"]');
    if (existing) {
      existing.addEventListener('load', callback, { once: true });
      setTimeout(callback, 1200);
      return;
    }
    var src = '//mypartsuniverse.com/cdn/shop/t/18/assets/pu-battery-ymm-fitment.js';
    var script = document.createElement('script');
    script.src = src + '?pu_fallback=' + Date.now();
    script.onload = callback;
    document.head.appendChild(script);
  }

  function ensureFinder() {
    if (document.querySelector('[data-pu-battery-finder-shell]')) return;
    loadFitment(function() {
      if (document.querySelector('[data-pu-battery-finder-shell]')) return;
      var data = window.PUBatteryYMMData || {};
      var products = data.products || {};
      var fitment = data.fitment || {};
      var modelsByMake = data.modelsByMake || {};
      var yearsByMake = data.yearsByMake || {};
      var collectionSection = document.querySelector('#shopify-section-collection-template');
      if (!collectionSection || !Object.keys(modelsByMake).length) return;

      var section = document.createElement('section');
      section.className = 'pu-battery-finder pu-battery-finder--fallback';
      section.setAttribute('aria-label', 'Battery fitment finder');
      section.setAttribute('data-pu-battery-finder-shell', '');
      section.innerHTML = [
        '<div class="pu-battery-finder__inner">',
          '<div class="pu-battery-finder__copy">',
            '<span class="pu-battery-finder__eyebrow">Battery finder</span>',
            '<h2>Find the right battery for your vehicle</h2>',
            '<p>Select your vehicle to see matching batteries from our catalog.</p>',
          '</div>',
          '<form class="pu-battery-finder__form" data-pu-battery-finder>',
            '<label><span>Year</span><select data-pu-battery-year aria-label="Select year"><option value="">Year</option></select></label>',
            '<label><span>Make</span><select data-pu-battery-make aria-label="Select make"><option value="">Make</option></select></label>',
            '<label><span>Model</span><select data-pu-battery-model aria-label="Select model" disabled><option value="">Model</option></select></label>',
            '<button type="submit">Find batteries</button>',
          '</form>',
          '<div class="pu-battery-finder__results" data-pu-battery-results hidden></div>',
        '</div>'
      ].join('');

      var style = document.createElement('style');
      style.textContent = [
        '.pu-battery-finder{margin:14px auto 16px;padding:0 15px;font-family:Work Sans,Arial,sans-serif}',
        '.pu-battery-finder__inner{display:grid;grid-template-columns:minmax(210px,.7fr) 1fr;gap:16px;align-items:center;padding:16px;border:1px solid #d9dee7;background:#f7f9fc}',
        '.pu-battery-finder__eyebrow{display:block;color:#0404cd;font-size:11px;font-weight:900;text-transform:uppercase}',
        '.pu-battery-finder h2{margin:4px 0;color:#182230;font-size:22px;font-weight:900}',
        '.pu-battery-finder p{margin:0;color:#667085;font-size:13px;line-height:1.4}',
        '.pu-battery-finder__form{display:grid;grid-template-columns:repeat(3,minmax(0,1fr)) auto;gap:9px;align-items:end}',
        '.pu-battery-finder label span{display:block;margin-bottom:5px;color:#344054;font-size:11px;font-weight:900;text-transform:uppercase}',
        '.pu-battery-finder select,.pu-battery-finder button{width:100%;min-height:42px;border-radius:4px;font-size:13px;font-weight:800}',
        '.pu-battery-finder select{border:1px solid #cfd6e2;background:#fff;color:#182230}',
        '.pu-battery-finder button{border:1px solid #0404cd;background:#0404cd;color:#fff}',
        '.pu-battery-finder__results{grid-column:1/-1;padding-top:10px}',
        '.pu-battery-finder__result-title{margin:0 0 4px!important;color:#182230!important;font-weight:900}',
        '.pu-battery-finder__result-note{margin:0 0 10px!important}',
        '.pu-battery-finder__option-list{display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:8px;margin:0;padding:0;list-style:none}',
        '.pu-battery-finder__option-link{display:flex;justify-content:space-between;gap:10px;padding:10px 12px;border:1px solid #d9dee7;background:#fff;color:#182230;text-decoration:none;font-weight:800}',
        '.pu-battery-finder__option-link em{color:#0404cd;font-style:normal;font-weight:900}',
        '@media(max-width:767px){.pu-battery-finder{margin:10px auto 12px;padding:0 10px}.pu-battery-finder__inner{display:block;padding:12px}.pu-battery-finder h2{font-size:18px}.pu-battery-finder__copy{margin-bottom:10px}.pu-battery-finder__form{grid-template-columns:1fr;gap:8px}.pu-battery-finder__option-list{grid-template-columns:1fr}}'
      ].join('');
      document.head.appendChild(style);
      collectionSection.parentNode.insertBefore(section, collectionSection);

      var yearSelect = section.querySelector('[data-pu-battery-year]');
      var makeSelect = section.querySelector('[data-pu-battery-make]');
      var modelSelect = section.querySelector('[data-pu-battery-model]');
      var resultsBox = section.querySelector('[data-pu-battery-results]');
      var currentYear = new Date().getFullYear() + 1;
      for (var year = currentYear; year >= 1960; year -= 1) {
        yearSelect.appendChild(new Option(String(year), String(year)));
      }
      Object.keys(modelsByMake).sort().forEach(function(make) {
        makeSelect.appendChild(new Option(make, make));
      });

      function refreshModels() {
        var make = makeSelect.value;
        modelSelect.innerHTML = '<option value="">Model</option>';
        modelSelect.disabled = !make;
        (modelsByMake[make] || []).forEach(function(model) {
          modelSelect.appendChild(new Option(model, model));
        });
      }

      function matchedProducts() {
        var year = yearSelect.value;
        var make = makeSelect.value;
        var model = modelSelect.value;
        if (!year || !make || !model) return [];
        var keys = [
          year + '|' + make + '|' + model,
          make + '|' + model,
          year + '|' + make
        ];
        var handles = [];
        keys.some(function(key) {
          if (fitment[key] && fitment[key].length) {
            handles = fitment[key];
            return true;
          }
          return false;
        });
        return handles.map(function(handle) {
          return products[handle];
        }).filter(Boolean);
      }

      function showMatches() {
        var matches = matchedProducts();
        var vehicle = [yearSelect.value, makeSelect.value, modelSelect.value].filter(Boolean).join(' ');
        if (!matches.length) {
          resultsBox.innerHTML = '<p class="pu-battery-finder__result-title">No exact match found for ' + vehicle + '.</p><p class="pu-battery-finder__result-note">Please contact us and we can confirm the correct battery.</p>';
          resultsBox.hidden = false;
          return;
        }
        resultsBox.innerHTML = '<p class="pu-battery-finder__result-title">Compatible battery options for ' + vehicle + '</p><p class="pu-battery-finder__result-note">Choose the recommended model that matches your preferred tier or group size.</p><ul class="pu-battery-finder__option-list">' + matches.map(function(product) {
          return '<li><a class="pu-battery-finder__option-link" href="/products/' + product.h + '"><span>' + product.b + '</span><em>View</em></a></li>';
        }).join('') + '</ul>';
        resultsBox.hidden = false;
      }

      yearSelect.addEventListener('change', function() {
        var make = makeSelect.value;
        if (make && yearsByMake[make] && yearsByMake[make].indexOf(yearSelect.value) === -1) {
          makeSelect.value = '';
          refreshModels();
        }
        resultsBox.hidden = true;
      });
      makeSelect.addEventListener('change', function() {
        refreshModels();
        resultsBox.hidden = true;
      });
      modelSelect.addEventListener('change', showMatches);
      section.querySelector('form').addEventListener('submit', function(event) {
        event.preventDefault();
        showMatches();
      });
    });
  }

  function scheduleFinderCheck() {
    setTimeout(ensureFinder, 800);
    setTimeout(ensureFinder, 2500);
    setTimeout(ensureFinder, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFinderCheck);
  } else {
    scheduleFinderCheck();
  }
})();
